export enum EPlatformNoticeCategoryType {
  General = "General",
  Release = "Release",
  Incident = "Incident",
  Maintenance = "Maintenance",
  Announcement = "Announcement",
}
